/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewChecked, ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { NotesService } from 'app/core/services/notes/notes.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { AttachmentType, ModuleUidKey, NotesOptions, NoteVisibilityType, ParamKey } from './notes.interface';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { EditorOptions } from '../text-editor/text-editor.interface';
import { FileUploaderService } from '../file-uploader/file-uploader.service';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { FileData } from '../file-uploader/file-uploader.interface';
import { FilePlaceholderOptions } from '../file-placeholder/file-placeholder.interface';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { NoteDialogService } from './note-dialog/note-dialog.service';
import { Subscription } from 'rxjs';
import { DownloadFileLinkService } from 'app/core/services/download_file_link/download_file_link.service';
import lgVideo from 'lightgallery/plugins/video';
import { LightGallery } from 'lightgallery/lightgallery';
import { GalleryDetailsComponent } from '../gallery-details/gallery-details.component';
import * as dayjs from 'dayjs';
import _ from 'lodash';
import { NoteDetailsComponent } from './note-details/note-details.component';
import { TextEditorService } from '../text-editor/text-editor.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import { moduleKey } from 'app/core/constants/constants';
import { MultiModulePickerService } from '../multi-module-picker/multi-module-picker.service';
import { LightGalleryService } from 'app/core/services/light-gallery.service';
import { TranslateService } from '@ngx-translate/core';
import moment, { Moment } from 'moment';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { AfterAppendSubHtmlDetail } from 'lightgallery/lg-events';
import { environment } from 'environments/environment';
import { BadgeOptions } from '../badge/badge.interface';
import { trigger, state, style, animate, transition, group} from '@angular/animations';
import { JobsService } from 'app/core/services/jobs/jobs.service';

const animations = [
  trigger('collapse', [
    state('false', style({
      height: '*',
      opacity: 1,
      visibility: 'visible',
    })),
    state('true', style({
      height: '0',
      opacity: 0,
      visibility: 'hidden',
    })),
    transition('false => true', [
      group([
        animate('100ms ease-in-out', style({ opacity: 0 })), // Gradual opacity fade
        animate('100ms ease-in-out', style({ height: '0' })), // Collapse height
      ]),
    ]),
    transition('true => false', [
      group([
        style({ visibility: 'visible' }), // Ensure visibility is restored immediately
        animate('100ms ease-in-out', style({ height: '*' })), // Expand height
        animate('100ms ease-in-out', style({ opacity: 1 })), // Gradual opacity fade back in
      ]),
    ]),
  ])
];
@Component({
    selector: 'notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: animations
})
export class NotesComponent implements OnInit, AfterViewChecked, OnChanges {
    @Input() module: string;
    @Input() moduleUID: string;
    @Input() options: NotesOptions;
    @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
    @Input() needRefresh?: boolean = false;
    @Input() allAssociates = null;
    @ViewChild('allNotes', { static: false }) allNotes!: ElementRef;

    showNotesTabLightGallery: boolean = false;
    user: any = null;
    companyPolicy: any = null;
    notes: any[] = [];
    loaded: boolean = true;
    allowRenderEditor: boolean = false;
    noteFormGroup: UntypedFormGroup;
    notesApiUrls: any;
    showEditorActions: boolean;
    localeKeys: any = {
        newest: 'notes.panel.sort.newest',
        oldest: 'notes.panel.sort.oldest'
    };
    visibilityOptions: any[] = [];
    sortMenuItems: any[] = [{
        displayName: 'Newest',
        displayKey: this.localeKeys.newest,
        action: 'sorting',
        actionType: 'newest'
    }, {
        displayName: 'Oldest',
        displayKey: this.localeKeys.oldest,
        action: 'sorting',
        actionType: 'oldest'
    }];
    selectedVisibility: any = null;
    selectedSortOptionKey: string = this.localeKeys.newest;
    isNewest: boolean = true;
    isUploaded: boolean = true;
    fileAttachments: any[] = [];
    uploadObservableSubscriptions: any = {};
    acceptedFileFormat: string = '';
    lightGallery: LightGallery;
    allImages: Array<any> = [];
    allImageMap: any = {};
    settings = {
        counter: true,
        dynamic: true,
        dynamicEl: this.allImages,
        loop: false,
        videojs: true,
        hideControlOnEnd: true,
        slideEndAnimation: false,
        appendSubHtmlTo: '.lg-outer',
        download: false,
        licenseKey: environment.lightGalleryKey,
        plugins: [lgVideo]
    };
    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    allModules = ['JOB','CUSTOMER','ORGANIZATION','PROPERTY','ESTIMATES','INVOICE','SERVICE_CONTRACTS','ASSETS', 'PROJECT'];
    associatedModules: any = {};
    getAssociatedModulesSubscription: Subscription;
    moduleKey= moduleKey;
    paramKey= ParamKey;
    currentNoteGallery: any[] = [];
    showNotifyUsersCheckbox: boolean = false;
    noteInitialValue = {
      noteEditorData: '',
      visibilityType: NoteVisibilityType.INTERNAL,
      noteAttachments: [],
      notifyUsers: false,
      isPinned: false,
    };
    pinnedNotes: any[] = [];
    isPinnedExpanded: boolean = true;
    customerBadgeOptions: BadgeOptions = null;

    constructor(
        private localisationService: LocalisationService,
        private utilityService: UtilityService,
        private dataCollectorService: DataCollectorService,
        private zuperDialogService: ZuperDialogService,
        private fileUploadService: FileUploaderService,
        private downloadFileService: DownloadFileLinkService,
        private noteDialogService: NoteDialogService,
        private notesService: NotesService,
        private toast: HotToastService,
        private formBuilder: UntypedFormBuilder,
        private translateService: TranslateService,
        private _resolve: ComponentFactoryResolver,
        private _injector: Injector,
        private textEditorService: TextEditorService,
        private _appRef: ApplicationRef,
        private multiModulePickerService: MultiModulePickerService,
        private lightGalleryService: LightGalleryService,
        private analyticsService: AnalyticsService,
        private changeDetection: ChangeDetectorRef,
        private jobsService: JobsService
    ) {
    }

    compileGalleryDetails(component: any, onAttach: any): any {
        const compFactory: ComponentFactory<Component> = this._resolve.resolveComponentFactory(component);
        const compRef = compFactory.create(this._injector);
        if (onAttach) { onAttach(compRef); }
        this._appRef.attachView(compRef.hostView);
        compRef.onDestroy(() => this._appRef.detachView(compRef.hostView));
        return compRef.location.nativeElement.children[0];
    }

    lgAppendSubHTML = (detail: AfterAppendSubHtmlDetail): void => {
        document.querySelector('#download-attachment').addEventListener('click', () => {
            const attachmentObject = {};
            attachmentObject['attachment'] = this.allImages[detail.index]?.['src'] || this.allImages[detail.index]?.['downloadUrl'];
            attachmentObject['attachment_name'] = this.allImages[detail.index]['name'];
            this.downloadNoteAttachment(attachmentObject);
        });
        document.querySelector('#copy-link').addEventListener('click', () => {
            this.utilityService.copyLink(this.allImages[detail.index]?.['src'] || this.allImages[detail.index]?.['downloadUrl']);
         });
    };

    lightOnInit = (detail: any): void => {
        this.lightGallery = detail.instance;
    };

    ngOnInit(): void {
        this.user = this.utilityService.user;
        this.companyPolicy = this.utilityService.companyPolicy;
        this.acceptedFileFormat = this.utilityService.acceptedFileFormat;
        this.notesApiUrls = this.notesService.notesApiUrls;
        this.allowToRenderEditor();

        this.showNotesTabLightGallery = true;
        this.showNotifyUsersCheckbox = this.options?.config?.showNotifyUsers ? true : false;
        if (this.showNotifyUsersCheckbox) {
          this.noteInitialValue.notifyUsers = true;
        }
        this.noteFormGroup = this.formBuilder.group(this.noteInitialValue);
        this.associatedModules[ParamKey[this.options?.module]] = [this.options?.defaultAssociatedModuleDetails];
        this.localisationService.setDefaultLanguage();
        this.updateVisibilityOptions();
        if (this.options) {
          if (this.options.data?.length > 0) {
            this.updateNotesCollection(this.options.data);
          } else if (!this.options?.disableAPICall) {
            this.getNotes();
          }
        }
        this.getAssociatedModulesSubscription = this.multiModulePickerService.associatedModules.subscribe(
            (data: any) => {
              const combinedModules: any = {
                ...this.associatedModules,
                ...data
              };
              _.each(_.keys(combinedModules), (module: string) => {
                if (module && data[module]) {
                  this.associatedModules[ParamKey[module.toUpperCase()]] =
                    data[module];
                } else if (module && !data[module]) {
                  this.associatedModules[ParamKey[module.toUpperCase()]] = null;
                }
              });
            });
        this.customerBadgeOptions = {
          type: 'VOIDED',
          displayKey: 'customer',
          displayName: this.utilityService.isCompanyB2BEnabled() ? 'Contact' : 'Customer'
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if('needRefresh' in changes){
            this.showNotesTabLightGallery = changes.needRefresh.currentValue;
            this.needRefresh = changes.needRefresh.currentValue;
        }

        if('options' in changes){
            const options = changes.options.currentValue;
            if(options?.data){
                this.updateNotesCollection(options.data);
            }
        }
      }

    updateVisibilityOptions(): void {
        this.visibilityOptions = [{
            displayName: 'Public',
            displayKey: 'notes.panel.visibility.public',
            icon: 'ti ti-world',
            visibilityType: NoteVisibilityType.PUBLIC,
            showIf: this.companyPolicy?.customer_portal_enabled
        }, {
            displayName: 'Internal',
            displayKey: 'notes.panel.visibility.internal',
            icon: 'ti ti-users',
            visibilityType: NoteVisibilityType.INTERNAL,
            showIf: true
        }, {
            displayName: 'Private',
            displayKey: 'text.only_me',
            icon: 'ti ti-lock',
            visibilityType: NoteVisibilityType.PRIVATE,
            showIf: true
        }, {
            displayName: 'Backoffice Only',
            displayKey: 'text.backoffice_only',
            icon: 'ti ti-user-shield',
            visibilityType: NoteVisibilityType.BACKOFFICE,
            showIf: this.user?.role?.role_key !== 'FIELD_EXECUTIVE'
        }];
        this.selectedVisibility = this.visibilityOptions.find((data: any)=> data?.visibilityType === NoteVisibilityType.INTERNAL);
    }

    ngAfterViewChecked(): void {
        if (this.needRefresh) {
            this.lightGallery.refresh(this.allImages);
            this.needRefresh = false;
        }
    }

    submitNote(): void {
        this.noteFormGroup.markAsTouched();
        const error = this.isInValidNote();
        if(!error) {
            this.postNewNote();
        }
    }

    updateNotesCount(notesCount: number): void {
        this.eventEmitter.emit({ notesCount: notesCount });
    }

    getNoteAttachmentType(attachment: string): string {
        if (attachment) {
            const extension: string = attachment.split('.').pop();
            return this.utilityService.getAttachmentTypeEnum(extension);
        }
    }

    loop = async (data: any, cb: any): Promise<any> => {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let index: number = 0; index < data.length; index++) {
            await cb(data[index]);
        }
    };

    getNotes(isFromSort? : boolean): void {
        if (this.options?.dataUrl) {
            this.loaded = false;
            let urlParams: any;
            if (this.options.params) {
                this.options.params['sort'] = this.isNewest ? 'DESC' : 'ASC';
                urlParams = this.utilityService.constructParam(this.options.params);
            }
            this.dataCollectorService.getData(this.options.dataUrl, urlParams)
                .subscribe((notes: any) => {
                    this.updateNotesCollection(notes.data);
                    this.pinnedNotes = notes.pinned_notes || [];
                        if (this.pinnedNotes.length > 0 && isFromSort) {
                            setTimeout(() => {
                                this.allNotes.nativeElement.scrollIntoView({ block: 'start' });
                            }, 0);
                        }
                    this.loaded = true;
                }, (_error: any) => {
                    this.loaded = true;
                });
        }
    }

    updateNotesCollection(notes: any): void {
        this.notes = this.updateNotes(notes);
        this.changeDetection.detectChanges();
        this.createLightGalleryCollection();
        this.updateNotesCount(this.notes.length);
    }

    async createLightGalleryCollection(): Promise<void> {
        this.allImages = [];
        await this.loop(this.notes, async (note) => {
            if (note?.attachments?.length > 0) {
                await this.loop(note.attachments, async (attachment) => {
                    const data = {
                        created_by_first_name: note.created_by?.first_name,
                        created_by_last_name: note.created_by?.last_name,
                        created_at: note.created_at,
                        attachment_name: attachment.attachment_name,
                        size: attachment.attachment_size,
                        url: attachment.attachment
                    };
                    const attachmentType: string = this.getNoteAttachmentType(attachment.attachment);
                    if (note?.geo_cordinates) {
                        data['geo_cordinates'] = note.geo_cordinates;
                    }
                    if (attachmentType === 'IMAGE') {
                        const imageDetails: any = this.compileGalleryDetails(GalleryDetailsComponent, (c) => { c.instance.data = data; });
                        await new Promise((resolve) => {
                            setTimeout(() => {
                                this.allImages.push({
                                    'src': attachment.attachment,
                                    'name': attachment.attachment_name,
                                    'subHtml': imageDetails.outerHTML
                                });
                                resolve(true);
                            },);
                        });
                    } else if (attachmentType === 'VIDEO') {
                        const videoDetails: any = this.compileGalleryDetails(GalleryDetailsComponent, (c) => { c.instance.data = data; });
                        await new Promise((resolve) => {
                            setTimeout(() => {
                                this.allImages.push({
                                    name: attachment.attachment_name,
                                    downloadUrl: attachment.attachment,
                                    mediaType: 'video',
                                    video: {
                                        'source': [{
                                            'src': attachment.attachment,
                                            'type': 'video/mp4'
                                        }],
                                        'attributes': {
                                            'preload': false,
                                            'controls': true
                                        }
                                    },
                                    subHtml: videoDetails.outerHTML
                                });
                                resolve(true);
                            },);
                        });
                    }
                });
            }
        });
        if (this.allImages.length > 0) {
            this.lightGallery.refresh(this.allImages);
            this.allImages.forEach((ele, i) => {
                if (ele?.src) {
                    this.allImageMap[ele.src] = {};
                    this.allImageMap[ele.src]['index'] = i;
                    this.allImageMap[ele.src]['attachment_name'] = ele.name;
                } else if (ele?.video?.source?.[0]?.src) {
                    this.allImageMap[ele?.video?.source?.[0]?.src] = {};
                    this.allImageMap[ele?.video?.source?.[0]?.src]['index'] = i;
                    this.allImageMap[ele?.video?.source?.[0]?.src]['attachment_name'] = ele.name;
                }
            });
        }
    }

    getCursorStyle(url: string): any {
        const attachmentType: string = this.getNoteAttachmentType(url);
        return {
            cursor: (attachmentType === 'IMAGE' || attachmentType === 'VIDEO') ? 'zoom-in' : 'pointer'
        };
    }

    openGallery(attachments: any[], url: string): void {
        const attachmentType: string = this.getNoteAttachmentType(url);
        if (attachmentType === 'IMAGE' || attachmentType === 'VIDEO') {
            this.currentNoteGallery = [];
            let attachmentIndex: number = -1;
            // const viewableAttachments: any[] = this.getViewableAttachments(attachments);
            // viewableAttachments.forEach((attachment: any) => {
            //     const filteredValue: any = this.allImages.find((value: any) => (value.src === attachment.attachment || value.downloadUrl === attachment.attachment));
            //     if (filteredValue) {
            //         this.currentNoteGallery.push(filteredValue);
            //     }
            // });
            this.allImages.forEach((value: any, index: number) => {
                if (value.src === url || value.downloadUrl === url) {
                    attachmentIndex = index;
                    return 0;
                }
            });
            if (attachmentIndex > -1) {
                // this.lightGallery.refresh(this.allImages);
                this.lightGallery.openGallery(attachmentIndex);
            }
        }
    }

    postNewNote(): void {
        if (this.validateNoteType() === true) {
            const createNoteDialog: any = this.zuperDialogService.open({
                title: this.translateService.instant('confirm.private.header',{type:'Note'}),
                type: 'error',
                message: this.translateService.instant('confirm.private.message',{type:'note'})
                    + '<p class="font-medium text-md mt-2 text-red-600">' + this.translateService.instant('notes.private.note.alert_message') + '</p>',
                actions: {
                    confirm: {
                        show: true,
                        label: 'Create Note',
                        color: 'error',
                        confirmDisplayKey: 'create.note.text'
                    },
                    cancel: {
                        show: true,
                        label: 'Cancel',
                        cancelDisplayKey: 'cancel.text'
                    }
                }
            });
            createNoteDialog.afterClosed().subscribe((result: any) => {
                if (result === true) {
                    this.createNote();
                }
            });
        } else {
            this.createNote();
        }
    }

    createNote(): void {
        if (!this.options.disableAPICall) {
            if (this.options?.dataUrl) {
                const payLoad: any = this.getNewNoteModel();
                this.dataCollectorService.postData(this.options.dataUrl, payLoad)
                    .subscribe(
                        (response: any) => {
                            this.resetForm();
                            this.associatedModules = {};
                            this.associatedModules[ParamKey[this.options?.module]] = [this.options?.defaultAssociatedModuleDetails];
                            this.toast.success(response.message);
                            this.getNotes();
                            this.fileUploadService.notesAttachments.next([]);
                            this.trackEvents();
                        }, (_error: any) => {
                        });
            }
        } else if (['INVOICE', 'ESTIMATE'].includes(this.module)) {
            const value: any = this.noteFormGroup.value;
            // const uid = ParamKey[this.module];
            // const model = {
            //     note: {
            //         attachments: [],
            //         is_private: false,
            //         note: value.noteEditorData,
            //         note_type: AttachmentType.TEXT,
            //         user_mentions: []
            //     },
            //     notify_users: true
            // };
            // model.note[uid] = this.moduleUID;
            const payLoad: any = {
                data: {
                    notes: [{
                        content: value.noteEditorData || ''
                    }],
                    type: 'NOTE'
                },
                module_name: this.module,
                module_uid: this.moduleUID
            };
            this.postData(payLoad);
        }
    }

    trackEvents(): void {
        const trackEventOptions = this.options?.trackEventOptions;
        if (trackEventOptions) {
            if (trackEventOptions?.trigger === 'onNewNoteAdded' && trackEventOptions?.eventName) {
                this.analyticsService.trackEvent(trackEventOptions?.eventName);
            }
        }
    }

    editNote(note: any): void {
        this.allowRenderEditor = false;
        this.fileUploadService.notesPreviewFiles.next(note?.attachments ? [...note.attachments] : []);
        const editNoteDialog: MatDialogRef<NoteDialogComponent> = this.zuperDialogService.openCustom(NoteDialogComponent,
            {
                extraClass: 'note-dialog-file-uploader',
                data: {
                    header: {
                        titleDisplayKey: 'text.edit_note',
                        titleDisplayName: 'Edit Note'
                    },
                    footer: {
                        submitDisplayKey: 'edit.note.dialog.update',
                        submitDisplayName: 'Update Note',
                        closeDisplayKey: 'close.text',
                        closeDisplayName: 'Close',
                        enablePrivacy: true
                    },
                    note: note,
                    defaultAssociatedModule: this.options.module,
                    defaultAssociatedModuleDetails: this.options.defaultAssociatedModuleDetails,
                    config: {
                        editorOptions: {
                            isEnabled: true,
                            options:  { ...this.getEditorOptions(), ...{ editorId: 'edit_note_text_editor'}}
                        },
                        uploaderOptions: {
                            isEnabled: true,
                            options: <FileData>{
                                uploadFileFor:'NOTE',
                                multiple: this.options.fileUploaderOptions?.multiple ?? true,
                                setMaxLimit: true,
                                attachmentType: this.options.config.attachments?.attachmentType ?? '',
                                showProgress: false,
                                showPreview: false,
                                allowFileTypes: this.utilityService.notesSupportedFileTypes,
                                description: {
                                    descriptionKey: 'notes.panel.description',
                                    descriptionName: 'Supported Files: Image, Video, Audio, PDF, DOC, XLS, MSG, EML, Zip'
                                },
                                module: this.module,
                                moduleUid: this.moduleUID
                            }
                        },
                    },
                    allAssociates: this.allAssociates,
                }
            });
        editNoteDialog.disableClose = true;
        const onSubmitClicked: any = this.noteDialogService.onSubmitClicked.subscribe((response: any) => {
            editNoteDialog.close(response);
        });
        editNoteDialog.afterClosed().subscribe((result: any) => {
            this.allowToRenderEditor();
            this.textEditorService.focusEditor.next(false);
            onSubmitClicked.unsubscribe();
            this.fileUploadService.notesPreviewFiles.next([]);
            if (result) {
                this.updateNote(result);
            }
        });
    }

    updateNote(value: any): void {
        if (this.options?.dataUrl) {
            const payLoad: any = {
                note: {
                    attachments: value.attachments && value.attachments.length > 0 ? value.attachments.filter((data: any) => !!data) : [],
                    note: value.note,
                    user_mentions: this.validateMentions(value.note),
                    is_private: value.isPrivate,
                    // is_v2_note: value.is_v2_note ? true : false,
                    visible_to_customer: value.visibleToCustomer,
                    visible_to_fe: value.isBackOfficeVisible
                },
            };
            if(!_.isEmpty(value.associatedModules)){
                _.each(_.keys(value.associatedModules), (module: string)=>{
                    if(module){
                        payLoad.note[ParamKey[module.toUpperCase()]] = value.associatedModules[module]?.length > 0 ? value.associatedModules[module][0][ModuleUidKey[module.toUpperCase()]] : null;
                    }
                });
            }
            this.dataCollectorService.putData(this.notesService.updateUrl(this.options.dataUrl, value.noteUID), payLoad)
                .subscribe(
                    (response: any) => {
                        this.toast.success(response.message);
                        this.getNotes();
                        this.jobsService.fetchAttachmentCount(this.module, this.moduleUID);
                        this.associatedModules = {};
                        this.associatedModules[ParamKey[this.options?.module]] = [this.options?.defaultAssociatedModuleDetails];
                    }, (_error: any) => {
                    });
        }
    }

    deleteNote(_event: any, note: any): void {
        const deleteNoteDialog: any = this.zuperDialogService.open({
            title: this.utilityService.getLocaleValue('text.delete_note'),
            type: 'error',
            message: this.utilityService.getLocaleValue('notes.confirm.delete.message'),
            actions: {
                confirm: {
                    show: true,
                    label: 'Delete',
                    color: 'error',
                    confirmDisplayKey: 'delete.text'
                },
                cancel: {
                    show: true,
                    label: 'Cancel',
                    cancelDisplayKey: 'cancel.text'
                }
            }
        });
        deleteNoteDialog.afterClosed().subscribe((result: any) => {
            if (result === true) {
                if (!this.options.disableAPICall) {
                    if (this.options?.dataUrl) {
                        this.dataCollectorService.deleteData(this.options.dataUrl + '/' + note.note_uid)
                            .subscribe(
                                (response: any) => {
                                    this.toast.success(response.message);
                                    this.getNotes();
                                }, (_error: any) => {
                                });
                    }
                } else if (['INVOICE', 'ESTIMATE'].includes(this.module)) {
                    const params: any = {
                        item_uid: note.note_uid,
                        module_name: this.module,
                        module_uid: this.moduleUID,
                        type: 'NOTE'
                    };
                    this.deleteData(params);
                }
            }
        });
    }

    changeNoteMode(_event: any, note: any, modeType: string): void {
        let dialogInfo: any = {
            type: 'notes.panel.visibility.public',
            alertMessage: 'notes.public.note.alert_message',
            isPrivate: false,
            isCustomerVisible: true,
            isBackOfficeVisible: true
        };
        if (modeType === NoteVisibilityType.INTERNAL) {
            dialogInfo = {
                type: 'notes.panel.visibility.internal',
                alertMessage: 'notes.internal.note.alert_message',
                isPrivate: false,
                isCustomerVisible: false,
                isBackOfficeVisible: true
            };
        } else if (modeType === NoteVisibilityType.PRIVATE) {
            dialogInfo = {
                type: 'text.only_me',
                alertMessage: 'notes.private.note.alert_message',
                isPrivate: true,
                isCustomerVisible: false,
                isBackOfficeVisible: false
            };
        } else if (modeType === NoteVisibilityType.BACKOFFICE) {
            dialogInfo = {
                type: 'text.backoffice_only',
                alertMessage: 'notes.backoffice.note.alert_message',
                isPrivate: false,
                isCustomerVisible: false,
                isBackOfficeVisible: false
            };
        }
        const noteModeDialog: any = this.zuperDialogService.open({
            title: this.translateService.instant('notes.confirm.header.text'),
            type: 'error',
            message: `${this.translateService.instant('confirm.alert.message',{type:'note'})} '${this.translateService.instant(dialogInfo.type)}' ?`
                + (!dialogInfo.alertMessage ? '' : '<p class="font-medium text-md mt-2 text-red-600">' + this.translateService.instant(dialogInfo.alertMessage) + '</p>'),
            actions: {
                confirm: {
                    show: true,
                    label: 'Update',
                    color: 'error',
                    confirmDisplayKey: this.translateService.instant('update')
                },
                cancel: {
                    show: true,
                    label: 'Cancel',
                    cancelDisplayKey: 'cancel.text'
                }
            }
        });
        noteModeDialog.afterClosed().subscribe((result: any) => {
            if (result === true && this.options?.dataUrl) {
                const payLoad: any = this.getNewNoteModel(note);
                payLoad.note['is_private'] = dialogInfo.isPrivate;
                payLoad.note['visible_to_customer'] = dialogInfo.isCustomerVisible;
                payLoad.note['visible_to_fe'] = dialogInfo.isBackOfficeVisible;
                this.dataCollectorService.postData(this.options.dataUrl, payLoad);
                this.dataCollectorService.putData(this.options.dataUrl + '/' + note.note_uid, payLoad)
                    .subscribe(
                        (response: any) => {
                            this.toast.success(response.message);
                            this.getNotes();
                        }, (_error: any) => {
                        });
            }
        });
    }

    hasValidProfilePicture(profilePicture: string): boolean {
        if (profilePicture) {
            return profilePicture.indexOf('profile_picture.jpg') === -1;
        }
        return false;
    }

    // changeNoteType(_event: any): void {
    //     const isPrivateNote: boolean = this.noteFormGroup.get('privateNote').value;
    //     this.noteFormGroup.patchValue({ 'privateNote': !isPrivateNote });
    // }

    validateNoteType(): boolean {
        return this.options.config.enablePrivacy !== false && this.noteFormGroup.get('visibilityType').value === NoteVisibilityType.PRIVATE;
    }

    getNoteVisibility(note: any): NoteVisibilityType {
        return this.notesService.getNoteVisibility(note);
    }

    isPrivateNote(note: any): boolean {
        return note?.is_private === true;
    }

    isCurrentUser(user: any): boolean {
        if (user) {
            return user.user_uid === this.user.user_uid;
        }
        return false;
    }

    sortMenuClick(item: any): void {
        this.selectedSortOptionKey = item.displayKey;
        if (item.action === 'sorting') {
            this.isNewest = item.actionType === 'newest';
            this.getNotes(true);
        }
    }

    selectVisibilityOptions(mode: any): void {
        this.selectedVisibility = mode;
        this.noteFormGroup.patchValue({ 'visibilityType': mode.visibilityType });
    }

    notifyUsers(): void {
        this.noteFormGroup.patchValue({ 'notifyUsers': this.noteInitialValue.notifyUsers ? true : false });
    }

    getAttachmentType(attachment: string): string {
        let type: string = 'file';
        if (attachment) {
            const splittedValue: string[] = attachment.split('.');
            type = splittedValue[splittedValue.length - 1];
        }
        return type;
    }

    updateNotes(notes: any[]): any[] {
        const updatedNotes: any[] = [];
        notes.forEach((note: any) => {
            if ((!note.is_deleted) && !(this.isPrivateNote(note) && !this.isCurrentUser(note.created_by))) {
                if (note?.attachment) {
                    const fileType: string = this.getAttachmentType(note.attachment);
                    const name: string = 'Untitled' + (fileType !== 'file' ? '.' + fileType : '');
                    const attachmentType: string = this.isImageFileLink(note.attachment) ? 'IMAGE' : 'DOCUMENT';
                    note.attachments = note.attachments ?? [];
                    note.attachments.push({ attachment: note.attachment, attachment_name: name, attachment_type: attachmentType });
                } else if (note?.attachments?.length) {
                    note?.attachments.forEach((value: any) => {
                        if (!value.attachment_name) {
                            const fileType: string = this.getAttachmentType(value.attachment);
                            value.attachment_name = 'Untitled' + (fileType !== 'file' ? '.' + fileType : '');
                        }
                    });
                }
                updatedNotes.push(note);
            }
        });
        return updatedNotes;
    }

    downloadNoteAttachment(attachment: any): void {
        if (attachment.attachment) {
            const options: any = {
                params: {
                    'file_url': attachment.attachment
                },
                responseType: 'arraybuffer',
                observe: 'response'
            };
            this.downloadFileService.downloadFileFromLink(attachment.attachment_name, options);
        } else {
            this.toast.error('Invalid file');
        }
    }

    deleteNoteAttachment(attachment: any): void {
        if (attachment.attachment) {
            const urlParams: any = this.utilityService.constructParam({ attachment_uid: attachment.attachment_uid });
            this.dataCollectorService.deleteData(this.notesApiUrls.deleteUrl, urlParams).subscribe((response: any) => {
                this.toast.success(response.message);
            }, (error: any) => {
            });
        } else {
            this.toast.error('Invalid file');
        }
    }

    isImageFileLink(value: string): boolean {
        return (value.match(/\.(jpeg|jpg|gif|png|svg)$/) !== null);
    }

    isInValidNote(): boolean {
        if (this.noteFormGroup.touched && !this.noteFormGroup.get('noteAttachments')?.value?.length && !this.noteFormGroup.get('noteEditorData')?.value) {
                this.noteFormGroup.get('noteEditorData').setErrors({invalidForm: 'This field is required'});
                return true;
        }
        return false;
    }

    onFileChange(event: any): void {
        let fileList: any[] = Array.from(event?.target?.files ?? []);
        if (fileList.length > 0) {
            const existingFileCount: number = this.fileAttachments.length;
            //File Count validation
            if (fileList && ((fileList.length + this.fileAttachments.length) > this.companyPolicy.attachments.max_no_of_attachments)) {
                fileList.length = (this.companyPolicy.attachments.max_no_of_attachments - this.fileAttachments.length);
                this.toast.error(this.utilityService.getLocaleValue('maximum.file.reached_count.message', 'Reached maximum no of attachments'));
            }
            //File Size validation
            if (fileList?.length && this.companyPolicy?.attachments?.max_attachment_size) {
                const filteredFiles: any[] = [];
                fileList.forEach((file: any) => {
                    if (file.size < (1000000 * this.companyPolicy?.attachments?.max_attachment_size)) {
                        filteredFiles.push(file);
                    } else {
                        const content: string = file.name + ' ' + this.utilityService.getLocaleValue('maximum.file.size.message', 'exceeds the maximum allowed size');
                        this.toast.error(content);
                    }
                });
                fileList = filteredFiles;
            }
            this.fileAttachments = [...this.fileAttachments, ...fileList];
            fileList.forEach((file: any, index: number) => {
                const formData = new FormData();
                formData.append('attachment', file);
                formData.append('attachment_type', this.options?.config?.attachments?.attachmentType ?? '');
                formData.append('content_type', file.type);
                formData.append('attachment_name', file.name);
                const uploadObservable: Subscription = this.dataCollectorService.uploadfile(this.notesApiUrls.uploadUrl, formData).subscribe((response: any) => {
                    this.toast.close('fileUpload');
                    const attachmentType: string = this.getAttachmentType(response.data.attachment_path);
                    const attachmentData: any = {
                        attachment: response.data.attachment_path,
                        attachment_uid: response.data.attachment_uid,
                        attachment_name: response.data.attachment_name,
                        attachment_size: response.data.attachment_size,
                        attachment_type: this.getAttachmentTypeEnum(attachmentType)
                    };
                    this.fileAttachments[existingFileCount + index] = attachmentData;
                    this.uploadObservableSubscriptions['sup_' + index].unsubscribe();
                    delete this.uploadObservableSubscriptions['sup_' + index];
                    this.updateNoteAttachments();
                }, (error: any) => {
                    this.toast.close('fileUpload');
                    this.fileAttachments[existingFileCount + index] = null;
                    this.uploadObservableSubscriptions['sup_' + index].unsubscribe();
                    delete this.uploadObservableSubscriptions['sup_' + index];
                });
                this.uploadObservableSubscriptions['sup_' + index] = uploadObservable;
            });
        }
    }

    cancelUploading(index: number): void {
        if (this.uploadObservableSubscriptions['sup_' + index]) {
            this.uploadObservableSubscriptions['sup_' + index].unsubscribe();
            delete this.uploadObservableSubscriptions['sup_' + index];
            if (this.fileAttachments[index]) {
                this.fileAttachments[index] = null;
            }
            this.updateNoteAttachments();
        }
    }

    isReachedMaxAttachments(): boolean {
        return this.fileAttachments.length === this.companyPolicy.attachments.max_no_of_attachments;
    }

    getFileAttachmentCount(): number {
        return this.fileAttachments.filter(file => file !== null).length;
    }

    removeFileFromCollection(index: number): void {
        if (this.fileAttachments.length) {
            this.fileAttachments[index] = null;
            this.updateNoteAttachments();
        }
    }

    updateNoteAttachments(): void {
        this.noteFormGroup.patchValue({ 'noteAttachments': this.fileAttachments.filter(file => (file && file.name)).length ? [] : this.getActualFileAttachments() });
    }

    getActualFileAttachments(): any[] {
        return this.fileAttachments.filter(fileCol => (fileCol !== null && !fileCol.name));
    }

    resetForm(): void {
        this.fileAttachments = [];
        this.selectedVisibility = this.visibilityOptions.find((data: any)=> data?.visibilityType === NoteVisibilityType.INTERNAL);
        if(this.showNotifyUsersCheckbox){
          this.noteInitialValue.notifyUsers = true;
        }
        this.noteFormGroup.reset(this.noteInitialValue);
    }

    getEditorOptions(): EditorOptions {
        const allowMentions: boolean = !!this.options.config?.editorOptions?.allowMentions;
        return {
            imageUpload: false,
            allowMentions: allowMentions ? this.noteFormGroup.get('visibilityType').value !== NoteVisibilityType.PRIVATE : false,
            showTemplate: false,
            editorId: 'note_text_editor',
            module: this.module,
            moduleId: this.moduleUID,
            attachmentType: 'NOTE',
            placeholder: this.utilityService.getLocaleValue('notes.panel.editor.placeholder'),
            initUponFocus: this.options.config.initUponFocus,
            addAttachmentsInBody: false
        };
    }

    getAttachmentTypeEnum(attachmentType: string): string {
        const images: string[] = ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG', 'gif', 'DNG', 'dng'];
        const audio: string[] = ['mp3', 'wav', 'm4a', 'wma', 'MP3', 'WAV', 'M4A'];
        const video: string[] = ['mp4', 'avi', 'flv', 'mov', 'mpg', '3gp'];
        const docs: string[] = ['doc', 'docx', 'xls', 'xlsx', 'txt', 'pdf', 'DOCX', 'DOC'];

        if (images.includes(attachmentType)) {
            return AttachmentType.IMAGE;
        } else if (audio.includes(attachmentType)) {
            return AttachmentType.AUDIO;
        } else if (video.includes(attachmentType)) {
            return AttachmentType.VIDEO;
        } else if (docs.includes(attachmentType)) {
            return AttachmentType.DOCUMENT;
        }

        return AttachmentType.DOCUMENT;
    }

    getNewNoteModel(note?: any): any {
        // const uid = ParamKey[this.options.module];
        const value: any = this.noteFormGroup.value;
        let noteValue: any = {
            attachments: value.noteAttachments?.length > 0 ? value.noteAttachments.filter((data: any) => !!data) : [],
            is_private: value.visibilityType === NoteVisibilityType.PRIVATE,
            visible_to_customer: value.visibilityType === NoteVisibilityType.PUBLIC,
            visible_to_fe: value.visibilityType === NoteVisibilityType.PUBLIC || value.visibilityType === NoteVisibilityType.INTERNAL,
            note: value.noteEditorData,
            note_type: value.noteAttachments?.length ? AttachmentType.DOCUMENT : AttachmentType.TEXT,
            user_mentions: this.validateMentions(value.noteEditorData),
            is_pinned: value.isPinned ?? false
        };
        if (note) {
            noteValue = {
                attachments: note.attachments?.length > 0 ? note.attachments.filter((data: any) => !!data) : [],
                is_private: note.is_private,
                visible_to_customer: note.visible_to_customer ? true : false,
                visible_to_fe: note.visible_to_fe ? true : false,
                note: note.note,
                note_type: note.note_type,
                user_mentions: this.validateMentions(note.note)
            };
        }
        const model = {
            note: noteValue,
            notify_users: note ? (note.notify_users ?? false) : value.notifyUsers ?? false
        };
        // model.note[uid] = this.options.moduleUID;
        _.each(_.keys(this.associatedModules), (module: string)=>{
            if(module){
                model.note[ParamKey[module.toUpperCase()]] = this.associatedModules[module]?.length > 0 ? this.associatedModules[module][0][ModuleUidKey[module.toUpperCase()]] : null;
            }
        });
        return model;
    }

    validateMentions(noteValue: string): string[] {
        const regex = new RegExp('<a.*?href=.*?\/employees\/([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12})\/details.*?>', 'g');
        const regex2 = new RegExp('<a.*?href=.*?\/settings.*?;uid=([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}).*?>', 'g');
        const userMentionsId: string[] = [];
        let matches: any[] = [];
        // eslint-disable-next-line no-cond-assign
        while (matches = regex.exec(noteValue)) {
            userMentionsId.push(matches[1]);
        }
        // eslint-disable-next-line no-cond-assign
        while (matches = regex2.exec(noteValue)) {
            userMentionsId.push(matches[1]);
        }
        return userMentionsId;
    }

    allowToRenderEditor(): void {
        setTimeout(() => {
            this.allowRenderEditor = !this.options?.config?.editorOptions?.quickCreate;
            this.changeDetection.detectChanges();
        }, 100);
    }

    openAttachments(): void {
        const fileAttachments: any[] = [...this.noteDialogService.getUploadAttachmentModel(this.fileAttachments)];
        this.fileUploadService.notesAttachments.next(fileAttachments);
        this.fileUploadService.notesPreviewFiles.next(fileAttachments);
        this.options.fileUploaderOptions['setMaxLimit'] = true;
        this.options.fileUploaderOptions['moduleUid'] = this.moduleUID;
        this.options.fileUploaderOptions['module'] = this.module;
        this.options.fileUploaderOptions['attachmentType'] = 'NOTE';
        const attachmentDialog: any = this.zuperDialogService.openCustom(FileUploaderComponent,
            {
                extraClass: 'note-file-uploader',
                data: this.options.fileUploaderOptions
            });
        attachmentDialog.disableClose = true;
        attachmentDialog.afterClosed().subscribe((_result: any) => {
            const attachmentSubscription: Subscription = this.fileUploadService.notesAttachments.subscribe((attachments: any) => {
                const attachmentCollection: any[] = [];
                if (attachments) {
                    attachments.forEach((attachment: any) => {
                        if (attachmentCollection.length === this.companyPolicy.attachments.max_no_of_attachments) {
                            return 0;
                        }
                        const attachmentType: string = this.getAttachmentType(attachment.attachment_path);
                        attachmentCollection.push({
                            attachment: attachment.attachment_path,
                            attachment_uid: attachment.attachment_uid,
                            attachment_name: attachment.attachment_name,
                            attachment_size: attachment.attachment_size,
                            attachment_type: this.getAttachmentTypeEnum(attachmentType)
                        });
                    });
                    this.fileAttachments = attachmentCollection;
                    this.noteFormGroup.patchValue({ 'noteAttachments': this.fileAttachments });
                    this.changeDetection.detectChanges();
                }
            });
            attachmentSubscription.unsubscribe();
            this.fileUploadService.notesPreviewFiles.next([]);
            this.jobsService.fetchAttachmentCount(this.module, this.moduleUID);
        });
    }

    getPlaceholderOptions(attachment: any, showCloseIcon: boolean, showDownloadIcon: boolean): FilePlaceholderOptions {
        return {
            fileName: attachment.attachment_name ?? 'Untitled',
            fileSize: attachment.attachment_size,
            fileType: attachment.attachment_type,
            fileLink: attachment.attachment,
            showCloseIcon: showCloseIcon,
            showDownloadIcon: showDownloadIcon
        };
    }

    fileEventEmitHandler(event: any, index?: number): void {
        if (event) {
            if (event.type === 'download') {
                this.downloadNoteAttachment(event.data);
            }

            if (event.type === 'remove') {
                this.removeFileFromCollection(index);
            }
        }
    }

    postData(payload: any): void {
        this.eventEmitter.emit({ isLoading: true });
        this.dataCollectorService.postData(this.options.dataUrl, payload).subscribe(
            (response: any) => {
                this.resetForm();
                this.toast.success(response.message);
                //Call get API to update the attachment collection
                this.eventEmitter.emit({ isLoading: false, notesUpdated: true });
                this.fileUploadService.notesAttachments.next([]);
                this.trackEvents();
            }, (_error: any) => {
                this.eventEmitter.emit({ isLoading: false });
                this.fileUploadService.notesAttachments.next([]);
            });
    }

    deleteData(params: any): void {
        this.eventEmitter.emit({ isLoading: true });
        this.dataCollectorService.deleteData(this.options.dataUrl, params).subscribe(
            (response: any) => {
                this.toast.success(response.message);
                //Call get API to update the attachment collection
                this.eventEmitter.emit({ isLoading: false, notesUpdated: true });
            }, (_error: any) => {
                this.eventEmitter.emit({ isLoading: false });
            });
    }

    getViewableAttachments(attachments: any[]): any[] {
        const viewableAttachments: any[] = [];
        attachments.forEach((attachment: any) => {
            const attachmentType: string = this.getNoteAttachmentType(attachment?.attachment);
            if (attachmentType === 'IMAGE' || attachmentType === 'VIDEO') {
                viewableAttachments.push(attachment);
            }
        });
        return viewableAttachments;
    }

    getNonViewableAttachments(attachments: any[]): any[] {
        const nonViewableAttachments: any[] = [];
        attachments.forEach((attachment: any) => {
            const attachmentType: string = this.getNoteAttachmentType(attachment?.attachment);
            if (attachmentType !== 'IMAGE' && attachmentType !== 'VIDEO') {
                nonViewableAttachments.push(attachment);
            }
        });
        return nonViewableAttachments;
    }

    initEditor(event): void {
        this.showEditorActions = event;
    }

    openNoteDetails(note: any): void{
        const viewNoteDialog = this.zuperDialogService.openCustom(NoteDetailsComponent,{
            extraClass: 'note-details-dialog',
            data: {
                noteUid: note.note_uid,
                module: moduleKey[this.module],
                showEditIcon: !(this.options.config?.editorOptions?.quickCreate || this.options.config?.menuOptions?.deleteOnly) && (this.isCurrentUser(note.created_by) || this.user?.role?.role_key === 'ADMIN')
            }
        });
        viewNoteDialog.disableClose = true;
        viewNoteDialog.afterClosed().subscribe((result: any) => {
            this.fileUploadService.notesPreviewFiles.next([]);
            if (result) {
                this.editNote(note);
            }
        });
    }

    openAssociationsDrawer(): void{
        this.eventEmitter.emit({
            'openDrawer': true,
            'drawerType': 'multiModulePicker',
            'drawerModule': this.options.module
        });
        this.multiModulePickerService.setDefaultModule(this.options.module);
        this.multiModulePickerService.setAssociatedModules(this.associatedModules);
    }

    getAssociationsCount(note?: any): number{
        let associationCount = -1;
        _.each(this.allModules,(module: string)=>{
            if(note && note[ParamKey[module]]){
                associationCount++;
            }
        });
        return associationCount;
    }

    getAssociatedModuleIcon(module: string): string {
        return ModuleIcon[moduleKey[module]];
    }

    getAssociatedModuleName(module: string, associatedDetails: any): string {
        module = moduleKey[module] ?? module;
        if(!_.isEmpty(associatedDetails)){
            switch(module){
                case 'JOB':
                    return `${associatedDetails?.work_order_number?associatedDetails?.work_order_number+' - ':''}${associatedDetails?.job_title}`;
                case 'CUSTOMER':
                    return `${associatedDetails?.customer_first_name} ${associatedDetails?.customer_last_name ?? ''}`;
                case 'ORGANIZATION':
                    return `${associatedDetails?.organization_name}`;
                case 'PROPERTY':
                    return `${associatedDetails?.property_name}`;
                case 'ESTIMATES':
                case 'ESTIMATE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.estimate_no || ''}`;
                case 'INVOICE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.invoice_no || ''}`;
                case 'ASSETS':
                    return `${associatedDetails?.asset_code?associatedDetails?.asset_code+' - ':''}${associatedDetails?.asset_name ?? ''}`;
                case 'SERVICE_CONTRACT':
                case 'SERVICE_CONTRACTS':
                    return `${associatedDetails?.contract_number?associatedDetails.contract_number+' - ':''}${associatedDetails?.contract_name}`;
                case 'PROJECT':
                    return `${associatedDetails?.project_number ? associatedDetails.project_number+' - ':''}${associatedDetails?.project_name}`;
            }
        }
    }

    checkModuleIsAssociated(module?: any): boolean{
        if(this.associatedModules?.[ParamKey[module]] && this.associatedModules?.[ParamKey[module]].length>0){
            return true;
        }
        else{
            return false;
        }
    }

    attachmentsAdded(attachment): any{
        this.fileAttachments = [...this.fileAttachments,...attachment];
        this.noteFormGroup.patchValue({ 'noteAttachments': this.fileAttachments });
    }

    isNoteModified(note: any): boolean {
        const createdAt: Moment = moment(note.created_at, 'YYYY-MM-DD HH:mm:ss');
        const updatedAt: Moment = moment(note.updated_at, 'YYYY-MM-DD HH:mm:ss');
        const pinnedAt:  Moment = moment(note?.pinned_at, 'YYYY-MM-DD HH:mm:ss');
        if (!note || !createdAt || !updatedAt) {
            return false;
        }
        if (note.is_pinned) {
            return !updatedAt?.isSame(pinnedAt);
        } else {
            return updatedAt?.isAfter(createdAt);
        }
    }

    changeNotePinnedStatus(): void {
        this.noteFormGroup.get('isPinned').patchValue(!this.noteFormGroup.get('isPinned').value);
    }

    pinUnpinNote(note): void {
        if (this.options?.dataUrl) {
            this.dataCollectorService.postData(this.notesService.getNotePinUrl(this.options.dataUrl, note.note_uid), '')
                .subscribe({
                    next: (response: any) => {
                        this.getNotes();
                    },
                    error: ((_error: any) => {
                    })
                });
        }
    }

    ngDestroy(): void{
        this.getAssociatedModulesSubscription.unsubscribe();
    }
}
